import { render, staticRenderFns } from "./NuevoPedidoModalComponent.vue?vue&type=template&id=1304e4a7&"
import script from "./NuevoPedidoModalComponent.vue?vue&type=script&lang=js&"
export * from "./NuevoPedidoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports